import { stringify } from "query-string";

function ExportToTxt({ type, startDate, endDate, department, keyword, token }) {
  return (
    <a
      href={`/api/message/export/txt/?${stringify({
        type,
        start_date: startDate,
        end_date: endDate,
        department,
        keyword,
        token,
      })}`}
      target="_blank"
    >
      导出
    </a>
  );
}

export default ExportToTxt;
